module.exports = __webpack_public_path__ + "static/raiden-8eb2b3262efeb706892b078f50add3d2.png";